import styled from "styled-components";
import Text from "common/Typography/Text";
import { sharedLib } from "@shared/services/shared.service.ts";
import useQuery from "utils/hooks/useQuery";
import { skipToken } from "@reduxjs/toolkit/query";
import { CSSProperties } from "react";
import UserAvatar from "common/Avatars/UserAvatar.tsx";

interface InvitingUserSummaryProps {
  style?: CSSProperties;
  hideBg?: boolean;
}

const InvitingUserSummary = ({ style, hideBg }: InvitingUserSummaryProps) => {
  const query = useQuery();
  const token = query.get("token");
  const { data } = sharedLib.sharedApi.configuration.useGetAccountInviteQuery(
    token ? { authToken: token } : skipToken
  );

  return (
    <Wrapper style={style} $hideBg={hideBg}>
      {!hideBg && (
        <Text>
          You will connect your exchange account to the following Cornix user:
        </Text>
      )}
      <SummaryWrapper>
        {data && (
          <UserAvatar user={data} avatarSize={40} fallbackInitialsSize={2} />
        )}
        <div>
          {data?.full_name && <Text>{data?.full_name}</Text>}
          {data?.username && <Text type="medium">{data?.username}</Text>}
        </div>
      </SummaryWrapper>
    </Wrapper>
  );
};

export default InvitingUserSummary;

const Wrapper = styled.div<{ $hideBg?: boolean }>`
  ${(p) =>
    !p.$hideBg &&
    `
  background-color: ${p.theme.colors.lightBlue};
  padding: 12px 16px;
  border-radius: 8px;
    `};
`;
const SummaryWrapper = styled.div`
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px solid ${(p) => p.theme.colors.midBlue};
  border-radius: 12px;
  display: flex;
  align-items: center;
  column-gap: 12px;
`;
